import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import { devLog } from "utils/devLog";

const policyMap = new Map();
export default function MMCMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);
  const [phoneNumber] = useState(props.currState.MemberLookup.phoneNumber || "");
  const [firstName, setFirstName] = useState(props.currState.MemberLookup.firstName || "");
  const [lastName, setLastName] = useState(props.currState.MemberLookup.lastName || "");
  const [memberNumber] = useState(props.currState.MemberLookup.memberNumber || "");
  const [last8Vin] = useState(props.currState.MemberLookup.last8Vin || "");

  const [searchType] = useState(props.currState.MemberLookup.searchType);
  const [memberInfo, setMemberInfo] = useState(undefined);
  const [contacts, setContacts] = useState(undefined);
  const [selectedContact, setSelectedContact] = useState(null);

  const [displaySelectionComponent, setDisplaySelectionComponent] = useState(false);
  const [partnerCode] = useState(props.currState.localGroup);

  useEffect(() => {
    // devLog(props);
    onSubmit();
  }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
      setDisplaySelectionComponent(success);
    }
  };

  const onMemberInfo = (memberInfo, contactInfo) => {
    if (typeof props.onMemberInfo === "function") {
      props.onMemberInfo(memberInfo, contactInfo);
      // devLog("memberInfo: " + memberInfo);
    }
  };

  const onSelect = (sc) => {
    // devLog("selected Contact: ", sc);
    setSelectedContact(sc);
    onMemberInfo(memberInfo, sc);
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    // devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      onMemberInfo(policyMap.get(searchValue), selectedContact);
      setMemberInfo(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        last8Vin: last8Vin,
        memberNumber: memberNumber,
        searchType: searchType,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        // devLog("JSON", json);
        if (typeof json.data.memberInfo === "object" && typeof json.data.memberInfo.contacts === "object") {
          if (!json.data.error) {
            setContacts(json.data.memberInfo.contacts);
            // onMemberInfo(json.data.memberInfo, selectedContact);
            setMemberInfo(json.data.memberInfo);
            onLoad(true);
          } else {
            setContacts(undefined);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.memberInfo === "object") {
          if (!json.data.error) {
            setContacts(undefined);
            // onMemberInfo(json.data.memberInfo, selectedContact);
            setMemberInfo(json.data.memberInfo);
            onLoad(true);
          } else {
            setContacts(undefined);
            setMemberInfo(undefined);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setContacts(undefined);
          setMemberInfo(undefined);
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setContacts(undefined);
          setMemberInfo(undefined);
          setError(t("BWC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        // devLog("error", e);
        setLoading(false);
        setContacts(undefined);
        setMemberInfo(undefined);
        setError(t("BWC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  return (
    <>
      <div className="formContainer">
        {memberInfo && !error && displaySelectionComponent && (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.Name")}:</b> {memberInfo.name}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.ConfirmCustomerPhoneNumber")}:</b>{" "}
                {memberInfo.phoneNumber ? memberInfo.phoneNumber : "N/A"}
              </div>
              <hr />
            </div>
          </div>
        )}
        {contacts && !error & displaySelectionComponent && (
          <div className="policyData">
            <div className="policyHeader driverContainer">
              <h4 className="driver-header">{t("description.ContactInformationHeader")}</h4>
              {/* <h6>{t("FIMC.ContractSearch.DropdownOptions3")}</h6> */}
              <hr />
              <>
                {contacts.map((contact, index) => {
                  return (
                    <div
                      key={index}
                      value={contact}
                      className={`vehicle-list-item ${selectedContact === contact ? "selected" : ""}`}
                      onClick={(e) => {
                        onSelect(contact);
                      }}
                    >
                      <div className="contact-list driver-list">
                        <input
                          className="vehicleSelector"
                          type="radio"
                          name="policy-vehicle"
                          checked={selectedContact === contact ? "selected" : ""}
                        />
                        <div value={contact} className="vehicle-list-item-col-1">
                          <h6 value={contact} className="name-h5">
                            {contact.firstName} {contact.lastName}
                          </h6>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            </div>
          </div>
        )}

        {!contacts && !error && displaySelectionComponent && (
          <>
            <div className="policyData">
              <div className="policyHeader driverContainer">
                <h4 className="driver-header">{t("description.AddContactInformationHeader")}</h4>
                <hr />
                <div className="contact-list driver-list">
                  <input
                    className="vehicleSelector"
                    type="radio"
                    name="policy-vehicle"
                    checked={selectedContact === undefined}
                    onClick={(e) => {
                      onSelect(undefined);
                    }}
                  />
                  <div className="vehicle-list-item-col-1">
                    <h6 className="name-h5">
                      {props.currState.FirstName} {props.currState.LastName}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}
